import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import type {Iappliance} from '../../types'

interface VoucherBanner {
    voucher_banner:string
}

interface OwlCarouselComponentProps {
  heading:string;
  description?:string;
  data:VoucherBanner[];
}


const VoucherOwlCarouselComponent: React.FC<OwlCarouselComponentProps> = ({heading, description, data}) => {

    useEffect(() => {
    if (data && data.length > 0) {
      const timer = setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [data]);
console.log("vouchers data",data)
const navigate = useNavigate();
  
  if(data?.length == 0 || data === undefined){
    return(
      <div></div>
    )
  }

  const settings = {
    dots: false, // Enable navigation dots
    infinite: data.length >=5, // Infinite scrolling
    speed: 700, // Transition speed in milliseconds
    slidesToShow: data.length >= 3 ? 5 : 5, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval in milliseconds
    
    responsive: [
      {
        breakpoint: 1024, // For screens less than 1024px
        settings: {
          slidesToShow: data.length >= 3 ? 3 : 4, // Show 3 slides
          slidesToScroll: 1, // Scroll 1 slide at a time
        //   infinite: data.length > 3,
        // autoplay: data.length > 3,
        },
      },
      {
        breakpoint: 768, // For screens less than 768px
        settings: {
          slidesToShow: 4, // Show 2 slides
          slidesToScroll: 1,
          // infinite: data.length > 3,
          // autoplay: data.length > 3,
        },
      },
      {
        breakpoint: 480, // For screens less than 480px
        settings: {
          slidesToShow: 2, // Show 1 slide
          slidesToScroll: 1,
          infinite: data.length > 2, // THIS is the key
        autoplay: data.length > 2,
        },
      },
    ],
  };


  

  return (
    <section className=" heavy new_voucher">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="Appliances-top-home-page"> {heading}</h2>
            <Slider {...settings}>
              {data.length > 0 ? (
                data.map((appliance, index) => (
                  <div className="item" key={index}  >
                    <div className="fetur_pro_img new_voucher_img">
                      <img loading="lazy" src={appliance.voucher_banner} alt={`${appliance.voucher_banner}`} />
                    </div>
                    
                  </div>
                ))
              ) : (
                null
              )}
            </Slider>

          </div>
        </div>
      </div>
    </section>
  );
};

export default VoucherOwlCarouselComponent;
